<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="closeDialog"
    >
      <!-- Contenido del modal -->
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="toggleNavigationDrawer()">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <v-toolbar-title>Editar operador</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="this.closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row class="d-flex justify-center ma-4">
          <h2
            :style="showNavigation ? 'padding-left: 56px' : 'padding-left: 0px'"
          >
            <b v-if="nameItem === ''"> Operador</b>
            <b v-else> {{ nameItem }}</b>
            <span>&nbsp;</span>|<span>&nbsp;</span>
            <b style="color: #2962ff" class="text-uppercase">{{
              infoOperator.name
            }}</b>
          </h2>
          <!-- <p
            v-show="viewLoginsUser()"
            style="
              position: fixed;
              right: 30px;
              top: 82px;
              font-size: 20px;
              font-family: sans-serif;
              color: #606060;
            "
          >
            {{ "Login " + infoOperator.login }}
          </p> -->
        </v-row>
        <!-- Contenido del componente Navegation -->
        <Navegation
          v-if="dialog"
          :showNavigationDrawer="showNavigation"
          @nameItem="nameItemNav"
          :style="showNavigation ? 'padding-left: 56px' : 'padding-left: 0px'"
        />
      </v-card>
      <!-- Fin del contenido del modal -->
    </v-dialog>
  </v-row>
</template>

<script>
import Navegation from "../commons/Navigation.vue";
import operators from "@/store/operadores/operators";
import modelsLiquidations from "@/store/modelosDeLiquidacion/modelsLiquidation";

export default {
  components: { Navegation },
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      showNavigation: true,
      nameItem: "",
      width: null,
    };
  },
  methods: {
    toggleNavigationDrawer() {
      this.showNavigation = !this.showNavigation;
    },
    closeDialog() {
      this.$emit("closeEditDialog");
    },
    nameItemNav(datos) {
      this.nameItem = datos;
    },
    viewLoginsUser() {
      if (this.width < 600) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    item() {
      return modelsLiquidations.state.edit;
    },
    infoOperator() {
      const { edit } = operators.state;
      return { name: edit.nombre, login: edit.login };
    },
  },
  mounted() {
    this.width = window.innerWidth;
  },
};
</script>
<style>
.v-toolbar__content {
  margin: 0;
}
</style>